var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"tw-py-2 tw-px-3 tw-text-center tw-cursor-pointer tw-opacity-100 tw-flex tw-items-center tw-gap-2",class:_setup.computedClass,attrs:{"disabled":_setup.props.disabled},on:{"click":function($event){return _setup.emit('button-click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }